var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.75 13.87H12.29V11.51C12.29 9.46 13.95 7.8 16 7.8C17.93 7.8 19.56 9.31 19.7 11.24C19.74 11.74 20.18 12.12 20.66 12.07C21.16 12.03 21.53 11.6 21.49 11.11C21.28 8.25 18.87 6 15.99 6C12.96 6 10.49 8.47 10.49 11.51V13.87H9.25C8.01 13.87 7 14.88 7 16.12V24.22C7 25.46 8.01 26.47 9.25 26.47H22.75C23.99 26.47 25 25.46 25 24.22V16.12C25 14.88 23.99 13.87 22.75 13.87Z"
  })));
};
export default SvgUnlock;